import React, { useEffect } from 'react'
import CustomerAuthForm from './components/CustomerAuthForm'
import { useLocation } from 'react-router-dom'
import Layout from '../home/theme/Layout'
import { useSelector } from 'react-redux'
import { appUrl } from '../../utils'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

export default function CustomerAuth() {
  const location = useLocation()
  const isRegister = location.pathname.includes('/cuenta/registro')
  const { sessionValidated, isCustomer } = useSelector(state => state.session)
  const history = useHistory()

  useEffect(() => {
    if (sessionValidated && isCustomer) {
      history.push(appUrl({ url: '/mis-tickets' }))
    } 
  }, [sessionValidated, isCustomer, history])

  return <Layout title={isRegister ? 'Crear cuenta' : 'Iniciar sesión'}>
    <div className="container">
      <div className="mt-5"></div>
      <CustomerAuthForm mode={isRegister ? 'register' : 'login'} />
    </div>
  </Layout>
}

